import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getSchoolsThunk } from "../store/reducers/schools/schools.thunks";
import SchoolsHeader from "../components/schools/SchoolsHeader";
import SchoolsTable from "../components/schools/SchoolsTable";
import SchoolViewModal from "../components/schools/SchoolViewModal";
import ConfirmToggleModal from "../components/schools/ConfirmToggleModal";
import SchoolFormModal from "../components/schools/SchoolFormModal";
import Loader from "../components/UI/Loader";
import Alert from "../components/UI/Alert";
import Pagination from "../components/UI/Pagination";
import {
  clearSchoolsError,
  setPage,
} from "../store/reducers/schools/schools.reducer";
import EmptyState from "./UI/EmptyState";

const SchoolsListLayer = () => {
  const dispatch = useDispatch();
  const {
    list,
    loading,
    error,
    page,
    next,
    previous,
    maxPageReached,
    search,
    count,
  } = useSelector((state) => state.schools);

  useEffect(() => {
    dispatch(getSchoolsThunk({ page, search }));
  }, [dispatch, page, search]);

  const handlePageChange = (newPage) => {
    dispatch(setPage(newPage));
  };

  return (
    <div className="card p-0 radius-12">
      <div className="card-body p-24">
        <SchoolsHeader />

        {/* ERROR */}
        {error && (
          <Alert
            message={error}
            variant="error"
            onClose={() => dispatch(clearSchoolsError())}
          />
        )}

        {/* LOADING */}
        {loading ? (
          <Loader center text="Cargando escuelas..." delay={200} />
        ) : (
          <>
            {/* EMPTY STATE */}
            {list.length === 0 ? (
              <EmptyState
                icon={
                  search ? "mdi:magnify-remove-outline" : "mdi:school-outline"
                }
                title={
                  search
                    ? "No se encontraron escuelas"
                    : "No hay escuelas registradas"
                }
                description={
                  search
                    ? "Intenta con otra búsqueda"
                    : "Comienza agregando una nueva escuela"
                }
              />
            ) : (
              <>
                {/* TABLE */}
                <SchoolsTable schools={list} search={search} />

                {/* PAGINATION */}
                <Pagination
                  page={page}
                  count={count}
                  pageSize={10}
                  onPageChange={handlePageChange}
                />
              </>
            )}
          </>
        )}
      </div>

      {/* MODALES */}
      <SchoolViewModal />
      <SchoolFormModal />
      <ConfirmToggleModal />
    </div>
  );
};

export default SchoolsListLayer;
